export default __webpack_public_path__ + "static/media/marco-150x150.4135c311.png";